import React, { useEffect, useState } from "react";
import { Helpers } from "../helpers/helpers";
import { ICitationSentence, IEpiProps, IReference } from "../models/vertex-search-page-models";
import { useVertexSearchContext } from "../reducers/vertex-search-page-provider";
import { CitationSlider } from "./search-answer-citation-slider";
import { SearchAnswerReference } from "./search-answer-reference";

interface IProps {
    citationSentence: ICitationSentence
}

export const SearchAnswerCitations = (props: IProps) => {
    const [showCitations, setShowCitations] = useState(false);

    function onCitationLinkClick() {
        setShowCitations(!showCitations);
    }

    return (
        <React.Fragment>
            <button className={`vertex-search-overview-citation-button ${showCitations ? "vertex-search-overview-citation-button-active" : ""}`} type="button" onClick={() => onCitationLinkClick()}><svg className="svg-icon" aria-hidden="true" focusable="false">
                <use xlinkHref="#icon-link"></use>
            </svg><span className="sr-only">Open citation</span></button>
            {
                showCitations &&
                <div className="vertex-search-overview-citation">
                    <h5>{props.citationSentence.citations.length} {props.citationSentence.citations.length == 1 ? "Source" : "Sources"}</h5>
                    <div className="vertex-search-overview-citation-inner">
                        <CitationSlider
                            count={props.citationSentence.citations.length}
                        >
                            {props.citationSentence.citations.map((citation, index) => (
                                <SearchAnswerReference key={index} reference={citation} />
                            ))}
                        </CitationSlider>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}